import React, { useEffect, useRef } from 'react';

interface CallStreamProps {
  mediaStream: MediaStream | null;
}

export default function CallStream({ mediaStream }: CallStreamProps) {
  const refVideo = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!refVideo.current) return;
    refVideo.current.srcObject = mediaStream;
  }, [mediaStream]);

  return <video ref={refVideo} autoPlay style={{ display: 'none' }} />;
}
